var _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Kaggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "200px",
    height: "200px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M13,27c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S14.105,27,13,27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M77,12c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S77.552,12,77,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fce0a2",
    d: "M50,13c-20.435,0-37,16.565-37,37s16.565,37,37,37s37-16.565,37-37S70.435,13,50,13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#39c1d7",
    d: "M60.341,73.999c-0.46,0-1.134-0.149-1.725-0.858L48.18,59.684l-2.389,2.357v10.248 c0,1.019-0.676,1.702-1.683,1.702h-4.431c-1.004,0-1.678-0.684-1.678-1.702V22.733c0-1.019,0.674-1.703,1.678-1.703h4.431 c1.004,0,1.679,0.684,1.679,1.703v28.729l12.044-12.629c0.521-0.54,1.087-0.812,1.685-0.812h6.33c0.65,0,1.212,0.361,1.466,0.942 c0.256,0.587,0.154,1.3-0.247,1.732L53.861,53.931l12.823,17.474c0.053,0.069,0.139,0.167,0.225,0.265 c0.416,0.479,0.889,1.021,0.577,1.706C67.311,73.761,66.926,74,66.481,74C66.46,74,60.341,73.999,60.341,73.999z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M44.109,22.03c0.453,0,0.678,0.233,0.678,0.703V53.96l13.768-14.437 c0.32-0.332,0.641-0.504,0.961-0.504h6.329c0.64,0,0.723,0.74,0.486,0.995L52.548,53.831l13.33,18.165 C66.182,72.392,66.83,73,66.481,73c-0.007,0-0.014,0-0.022-0.001l-6.118,0c-0.367,0-0.683-0.17-0.957-0.5L48.279,58.18 l-3.489,3.443v10.666c0,0.47-0.231,0.703-0.682,0.703h-4.431c-0.453,0-0.678-0.235-0.678-0.703V22.733 c0-0.47,0.227-0.703,0.678-0.703H44.109 M44.109,20.03h-4.431c-1.552,0-2.678,1.137-2.678,2.703v49.556 c0,1.566,1.126,2.703,2.678,2.703h4.431c1.554,0,2.682-1.137,2.682-2.703v-9.829l1.289-1.273l9.723,12.538 c0.014,0.018,0.028,0.035,0.042,0.052c0.654,0.788,1.541,1.222,2.495,1.222l6.089,0C66.448,75,66.466,75,66.481,75 c0.841,0,1.575-0.464,1.915-1.211c0.578-1.27-0.275-2.25-0.734-2.777c-0.071-0.082-0.144-0.163-0.199-0.235L55.175,54.03 l12.573-12.602c0.017-0.017,0.034-0.035,0.051-0.053c0.674-0.727,0.847-1.857,0.43-2.813c-0.415-0.952-1.328-1.543-2.383-1.543 h-6.329c-0.604,0-1.511,0.193-2.4,1.115L46.787,48.965V22.733C46.787,21.167,45.661,20.03,44.109,20.03L44.109,20.03z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    x2: 40.5,
    y1: 39.138,
    y2: 52,
    fill: "#fff",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    x2: 40.5,
    y1: 33.681,
    y2: 37.463,
    fill: "#fff",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    x2: 40.5,
    y1: 24,
    y2: 32.149,
    fill: "#fff",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56.051,
    x2: 62.894,
    y1: 61.445,
    y2: 70.383,
    fill: "#fff",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 51.5,
    x2: 54.782,
    y1: 55.5,
    y2: 59.787,
    fill: "#fff",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M83,11c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S85.209,11,83,11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M87,22c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S88.105,22,87,22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M81,74c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S82.105,74,81,74z M15,59c-2.209,0-4,1.791-4,4 c0,2.209,1.791,4,4,4s4-1.791,4-4C19,60.791,17.209,59,15,59z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M25,85c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S26.105,85,25,85z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5,51c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S19.881,51,18.5,51z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M21,66c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S21.552,66,21,66z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80,33c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S80.552,33,80,33z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Kaggle);
export default __webpack_public_path__ + "static/media/icons8-kaggle.2c0bf1b2aa2a2d2a6faeea247722ce72.svg";
export { ForwardRef as ReactComponent };